unit UEditRemoteUserForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, UStampModel,
  Vcl.Imaging.pngimage, Vcl.Controls, WEBLib.ExtCtrls, UMainConfig, Types,
  Vcl.Grids, WEBLib.Grids, WEBLib.Buttons;

type
  TEditRemoteUserForm = class(TForm)
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnBack: TImageControl;
    pnlFooter: TPanel;
    pnlStatus: TPanel;
    sgStatus: TStringGrid;
    pnlData: TPanel;
    WebLabel1: TLabel;
    edtRemoteUser: TEdit;
    WebLabel4: TLabel;
    edtRemoteUserNew: TEdit;
    btnStore: TBitBtn;
    function CheckMask: Boolean;
    procedure WebFormResize(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure btnBackClick(Sender: TObject);
    procedure btnStoreClick(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure WebFormOrientationChange(Sender: TObject;
      AOrientation: TScreenOrientation);
    procedure edtRemoteUserNewKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebFormCreate(Sender: TObject);
  private
    FMainConfig: TMainConfig;
    FFakStamp: TStampModel;
    FStamp: TStampModel;
    procedure GetLastFakStamp;
    procedure GetStatus;
    procedure SetMask;
    procedure StoreCallback(Sender: TObject);
    procedure SetMainConfig(const Value: TMainConfig);
    procedure SetFakStamp(const Value: TStampModel);
    procedure SetStamp(const Value: TStampModel);
  public
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
    property Stamp: TStampModel read FStamp write SetStamp;
    property FakStamp: TStampModel read FFakStamp write SetFakStamp;
  protected procedure LoadDFMValues; override; end;

var
  EditRemoteUserForm: TEditRemoteUserForm;

implementation

uses
  UUsermodel, UEssentialHelper, UGridHelper;

{$R *.dfm}
{ TForm1 }

procedure TEditRemoteUserForm.btnBackClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.Close;
end;

procedure TEditRemoteUserForm.btnStoreClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  if CheckMask then
  begin
    Self.MainConfig.User.OnPropertyChanged := StoreCallback;
    Self.MainConfig.User.UpdateRemoteUser(Self.MainConfig.Uri,
      edtRemoteUserNew.Text);
  end;
end;

function TEditRemoteUserForm.CheckMask: Boolean;
var
  error: string;
begin
  error := '';
  if (error = '') and (edtRemoteUserNew.Text = '') then
  begin
    error := 'Ihr neuer Anmeldename darf nicht leer sein!';
    edtRemoteUserNew.SetFocus;
  end;
  if error <> '' then
    MessageDLG(error, mtWarning, [mbOK]);
  Result := error = '';
end;

procedure TEditRemoteUserForm.edtRemoteUserNewKeyDown(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  Self.MainConfig.TimerReset;
end;

procedure TEditRemoteUserForm.GetLastFakStamp;
var
  st: TStampModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TStampModel then
    begin
      Self.FakStamp:=Sender as TStampModel;
      Self.WebFormResize(nil);
    end;
  end;

begin
  st := TStampModel.Create;
  st.PersonalNr := Self.MainConfig.User.PersonalNr;
  st.OnPropertyChanged := Callback;
  st.GetLastFakStamp(Self.MainConfig.Uri);
end;

procedure TEditRemoteUserForm.GetStatus;
var
  st: TStampModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TStampModel then
    begin
      Self.Stamp:=Sender as TStampModel;
      Self.WebFormResize(nil);
    end;
  end;

begin
  st := TStampModel.Create;
  st.PersonalNr := Self.MainConfig.User.PersonalNr;
  st.OnPropertyChanged := Callback;
  st.GetLastStamp(Self.MainConfig.Uri);
end;

procedure TEditRemoteUserForm.SetFakStamp(const Value: TStampModel);
begin
  FFakStamp := Value;
end;

procedure TEditRemoteUserForm.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
  Self.MainConfig.CurrentForm := Self.Name;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  if Self.MainConfig.CommonConfig.WorkOrderTimes then
    Self.GetLastFakStamp;
  Self.WebFormResize(Self);
  Self.GetStatus;
  Self.SetMask;
end;

procedure TEditRemoteUserForm.SetMask;
begin
  edtRemoteUser.Text := Self.MainConfig.User.Remote_User;
  edtRemoteUserNew.Text := '';
end;

procedure TEditRemoteUserForm.SetStamp(const Value: TStampModel);
begin
  FStamp := Value;
end;

procedure TEditRemoteUserForm.StoreCallback(Sender: TObject);
begin
  if Sender is TUserModel then
  begin
    if (Sender as TUserModel).Result.ResultValue then
    begin
      Self.MainConfig.User.Remote_User := edtRemoteUserNew.Text;
      Self.ModalResult := mrOK;
      Self.Close;
    end
    else
      MessageDLG((Sender as TUserModel).Result.ResultMessage,
        mtWarning, [mbOK]);
  end;
end;

procedure TEditRemoteUserForm.WebFormClose(Sender: TObject;
  var Action: TCloseAction);
begin
  if Self.MainConfig <> nil then
    Self.MainConfig.User.OnPropertyChanged := nil;
end;

procedure TEditRemoteUserForm.WebFormCreate(Sender: TObject);
begin
  Self.Stamp := nil;
  Self.FakStamp := nil;
end;

procedure TEditRemoteUserForm.WebFormOrientationChange(Sender: TObject;
  AOrientation: TScreenOrientation);
begin
  Self.Paint;
  Self.WebFormResize(Sender);
end;

procedure TEditRemoteUserForm.WebFormResize(Sender: TObject);
var
  i: Integer;
begin
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    btnBack.Width := 24;
    btnBack.Height := 24;
    btnBack.Top := 4;
    btnBack.Left := 4;
    lblHeader.Font.Size := 10;
    lblHeader.Top := 7;
    imgLogo.Width := 74;
    imgLogo.Height := 24;
    imgLogo.Top := 4;
    pnlHeader.Height := 32;
    pnlFooter.Visible := false;
    lblHeader.Caption := 'Anmeldenamen ändern';
    if Self.MainConfig <> nil then
      SetStatusGrid(sgStatus, Stamp, FFakStamp, true, pnlStatus,
        Self.MainConfig.User);
  end
  else
  begin
    btnBack.Width := 48;
    btnBack.Height := 48;
    btnBack.Top := 8;
    btnBack.Left := 8;
    lblHeader.Font.Size := 16;
    lblHeader.Top := 16;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.Top := 8;
    pnlHeader.Height := 64;
    pnlFooter.Visible := true;
    lblHeader.Caption := 'Winzeit - WebPortal - Anmeldenamen ändern';
    if Self.MainConfig <> nil then
      SetStatusGrid(sgStatus, Stamp, FFakStamp, false, pnlStatus,
        Self.MainConfig.User);
  end;
  pnlHeader.Width := Self.ClientWidth;
  pnlFooter.Width := pnlHeader.Width;
  lblHeader.Left := 64;
  lblHeader.Width := pnlHeader.ClientWidth - btnBack.Width - imgLogo.Width - 32;
  imgLogo.Left := pnlHeader.ClientWidth - imgLogo.Width - 16;
  pnlData.Left := (Self.ClientWidth - pnlData.Width) div 2;
  i := Self.ClientHeight - pnlHeader.Height - pnlStatus.Height - pnlData.Height;
  if pnlFooter.Visible then
    i := i - pnlFooter.Height;
  i := i div 2;
  if i < 0 then
    i := 0;
  pnlData.Top := pnlStatus.Top + pnlStatus.Height + i;
end;

procedure TEditRemoteUserForm.WebFormShow(Sender: TObject);
begin
  Self.WebFormResize(Sender);
  Self.ModalResult := mrNone;
end;

procedure TEditRemoteUserForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnBack := TImageControl.Create(Self);
  pnlFooter := TPanel.Create(Self);
  pnlStatus := TPanel.Create(Self);
  sgStatus := TStringGrid.Create(Self);
  pnlData := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  edtRemoteUser := TEdit.Create(Self);
  edtRemoteUserNew := TEdit.Create(Self);
  btnStore := TBitBtn.Create(Self);

  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  pnlStatus.BeforeLoadDFMValues;
  sgStatus.BeforeLoadDFMValues;
  pnlData.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  edtRemoteUser.BeforeLoadDFMValues;
  edtRemoteUserNew.BeforeLoadDFMValues;
  btnStore.BeforeLoadDFMValues;
  try
    Name := 'EditRemoteUserForm';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnOrientationChange', 'WebFormOrientationChange');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 640;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Picture.LoadFromFile('UEditRemoteUserForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal - Anmeldenamen '#228'ndern';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnBack.SetParentComponent(pnlHeader);
    btnBack.Name := 'btnBack';
    btnBack.Left := 16;
    btnBack.Top := 16;
    btnBack.Width := 32;
    btnBack.Height := 32;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.WidthPercent := 100.000000000000000000;
    btnBack.ChildOrder := 2;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnBack.Picture.LoadFromFile('UEditRemoteUserForm.pnlHeader.btnBack.Picture.png');
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 456;
    pnlFooter.Width := 640;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
    pnlStatus.SetParentComponent(Self);
    pnlStatus.Name := 'pnlStatus';
    pnlStatus.Left := 0;
    pnlStatus.Top := 64;
    pnlStatus.Width := 640;
    pnlStatus.Height := 28;
    pnlStatus.Align := alTop;
    pnlStatus.Caption := 'pnlStatus';
    pnlStatus.ChildOrder := 2;
    pnlStatus.ShowCaption := False;
    sgStatus.SetParentComponent(pnlStatus);
    sgStatus.Name := 'sgStatus';
    sgStatus.Left := 0;
    sgStatus.Top := 0;
    sgStatus.Width := 640;
    sgStatus.Height := 28;
    sgStatus.Align := alClient;
    sgStatus.ColCount := 4;
    sgStatus.FixedCols := 0;
    sgStatus.RowCount := 2;
    sgStatus.FixedRows := 0;
    sgStatus.Font.Charset := ANSI_CHARSET;
    sgStatus.Font.Color := clNavy;
    sgStatus.Font.Height := -16;
    sgStatus.Font.Name := 'Segoe UI Semibold';
    sgStatus.Font.Style := [fsBold];
    sgStatus.Options := [goRangeSelect,goFixedRowDefAlign];
    sgStatus.ParentFont := False;
    sgStatus.ScrollBars := ssNone;
    sgStatus.TabOrder := 0;
    sgStatus.RangeEdit.Max := 100.000000000000000000;
    sgStatus.RangeEdit.Step := 1.000000000000000000;
    sgStatus.HeightPercent := 100.000000000000000000;
    sgStatus.WidthPercent := 100.000000000000000000;
    pnlData.SetParentComponent(Self);
    pnlData.Name := 'pnlData';
    pnlData.Left := 232;
    pnlData.Top := 188;
    pnlData.Width := 176;
    pnlData.Height := 160;
    pnlData.Caption := 'pnlData';
    pnlData.ChildOrder := 3;
    pnlData.ShowCaption := False;
    WebLabel1.SetParentComponent(pnlData);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 8;
    WebLabel1.Top := 8;
    WebLabel1.Width := 95;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Ihr Anmeldename';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(pnlData);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 8;
    WebLabel4.Top := 56;
    WebLabel4.Width := 128;
    WebLabel4.Height := 15;
    WebLabel4.Caption := 'Ihr neuer Anmeldename';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    edtRemoteUser.SetParentComponent(pnlData);
    edtRemoteUser.Name := 'edtRemoteUser';
    edtRemoteUser.Left := 8;
    edtRemoteUser.Top := 24;
    edtRemoteUser.Width := 100;
    edtRemoteUser.Height := 22;
    edtRemoteUser.ChildOrder := 1;
    edtRemoteUser.Enabled := False;
    edtRemoteUser.HeightPercent := 100.000000000000000000;
    edtRemoteUser.TabOrder := 1;
    edtRemoteUser.Text := 'edtRemoteUser';
    edtRemoteUser.WidthPercent := 100.000000000000000000;
    edtRemoteUserNew.SetParentComponent(pnlData);
    edtRemoteUserNew.Name := 'edtRemoteUserNew';
    edtRemoteUserNew.Left := 8;
    edtRemoteUserNew.Top := 72;
    edtRemoteUserNew.Width := 100;
    edtRemoteUserNew.Height := 22;
    edtRemoteUserNew.ChildOrder := 1;
    edtRemoteUserNew.HeightPercent := 100.000000000000000000;
    edtRemoteUserNew.MaxLength := 10;
    edtRemoteUserNew.Text := 'edtRemote_User';
    edtRemoteUserNew.WidthPercent := 100.000000000000000000;
    SetEvent(edtRemoteUserNew, Self, 'OnKeyDown', 'edtRemoteUserNewKeyDown');
    btnStore.SetParentComponent(pnlData);
    btnStore.Name := 'btnStore';
    btnStore.Left := 8;
    btnStore.Top := 104;
    btnStore.Width := 160;
    btnStore.Height := 48;
    btnStore.Caption := #196'ndern';
    btnStore.Color := clNone;
    btnStore.Glyph.LoadFromFile('UEditRemoteUserForm.pnlData.btnStore.Glyph.png');
    btnStore.GlyphSize := 32;
    btnStore.HeightPercent := 100.000000000000000000;
    btnStore.WidthPercent := 100.000000000000000000;
    SetEvent(btnStore, Self, 'OnClick', 'btnStoreClick');
  finally
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
    pnlStatus.AfterLoadDFMValues;
    sgStatus.AfterLoadDFMValues;
    pnlData.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    edtRemoteUser.AfterLoadDFMValues;
    edtRemoteUserNew.AfterLoadDFMValues;
    btnStore.AfterLoadDFMValues;
  end;
end;

end.
